
<div style="padding:1rem;" class="animated faster fadeInUp">

  @if ($storage.hasSummaryExtras) {
    <div class="my-panel no-shadow mb-3">
      <div class="my-panel-body" style="font-size:0.9rem;">
        <app-tabit-order-info [options]="{from:'tip'}" style="transform: scale(0.9)"></app-tabit-order-info>
      </div>
    </div>
  }

  <!--START GRATUITY-->
  @if (tipOptions) {
    <div class="my-panel no-shadow mb-3">
      <div class="my-panel-body">
        <div class="_panel-title">
          <div>{{'gratuity' | translate}}</div>
        </div>
        <!--<div class="text-center text-info pb-2 position-relative" style="top:-5px" *ngIf="$storage.order.autoGratuity">
        {{app.translate('service_charges_applied', {name: $storage.order.autoGratuity.name})}}: {{$storage.order.autoGratuity.amount | lcurrency:'1.2-2'}}
      </div>-->
      <div class="gratuity-rows">
        <!--SEATED GRATUITY-->
        @if (tipOptions.valueType == 'percent') {
          @for (opt of tipOptions.values; track opt) {
            <button type="button" class="btn-bordered"
              [ngClass]="{'active': slectedGratuity == opt}"
              (mousedown)="setGratuity('p', opt)">
              <div>{{opt}}%</div>
              <div class="info">{{calculateGratuityFromPercent(opt) | lcurrency:currencyFormat}}</div>
            </button>
          }
        }
        <!--end SEATED GRATUITY-->
        <!--COURIER GRATUITY-->
        @if (tipOptions.valueType == 'amount') {
          @for (opt of tipOptions.values; track opt) {
            <button type="button" class="btn-bordered"
              [ngClass]="{'active': slectedGratuity == opt}"
              (mousedown)="setFixedValGratuity(opt)">
              <div>{{opt | lcurrency:'1.0-0'}}</div>
            </button>
          }
        }
        <!--end COURIER GRATUITY-->
      </div>
      <div class="gratuity-rows">
        <button type="button" (mousedown)="setManualGratuity('v')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'v'}">
          <span>{{ 'amount' | translate}} {{app.regionArgs.currency}}</span>
          @if (slectedGratuity == 'v') {
            <div class="info _lg">{{gratuity.amount | lcurrency:currencyFormat}}</div>
          }
        </button>
        <button type="button" (mousedown)="setManualGratuity('p')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'p'}">
          <span>{{ 'percent' | translate}} %</span>
          @if (slectedGratuity == 'p') {
            <div class="info _lg d-flex align-items-center justify-content-center"><span>{{gratuity.percent | number:'1.0-2'}}%</span><span class="ms-2">{{gratuity.amount | lcurrency:currencyFormat}}</span></div>
          }
        </button>
      </div>
      @if (gratuity.amount && $storage.gratuityPAWarning) {
        <div class="mt-1 text-accent text-center font-semi-bold text-xs animated faster slideInUp">
          <div>{{$storage.gratuityPAWarning}}</div>
        </div>
      }
    </div>
  </div>
}
<!--END GRATUITY-->

<!--START PONTS-->
@if (loyaltyService.loyaltyData?.pointsUsable && $storage.order.grandTotal) {
  <div class="my-panel no-shadow">
    <div class="my-panel-body">
      <div class="_panel-title">
        <div>{{'_LOYALTY.review_points' | translate}}</div>
      </div>
      <button type="button" style="height: auto;" class="btn-bordered btn-block shadow-sm"
        [class.button-shake]="pointsBalance.shake"
        [class.active]="pointsBalance.used"
        (mousedown)="getLoyaltyPoints()" >
        <div class="d-flex align-items-center justify-content-between px-3 py-2">
          <mat-icon svgIcon="loyalty_logo"></mat-icon>
          <div>
            @if (pointsBalance.used) {
              {{ '_LOYALTY.redeem_points_after' | translate:{points: pointsBalance.used} }}
            } @else {
              <div class="text-accent">{{ '_LOYALTY.redeem_points_prompt_1' | translate }}</div>
              <small>{{ '_LOYALTY.redeem_points_prompt_2' | translate:{points: pointsBalance.max | lcurrency } }}</small>
            }
          </div>
          <mat-icon svgIcon="loyalty_logo"></mat-icon>
        </div>
      </button>
    </div>
  </div>
}
<!--END POINTS-->

</div>

<div class="p-3 pb-4 fixed-bottom">
  <button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (mousedown)="continue()">
    <div class="_inner">
      <span>{{"continue" | translate}}</span>
      <b>{{(total  + gratuity.amount) - pointsBalance.used | lcurrency}}</b>
      <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
    </div>
  </button>
</div>
